export const USER_ROLES = {
  PLATFORM_ACCOUNT: 'xpay_platform_account',
  HBL_LOGO: 'HBL_LOGO',
  XPAY_USER: 'xpay_user',
  XPAY_ADMIN: 'xpay',
  XPAY_SUPER_ADMIN: 'xpay_super_admin',
  XPAY_BRAND_ADMIN: 'xpay_brand_admin',
  XPAY_REFUND: 'xpay_refund',
  XPAY_DEVELOPER: 'xpay_developer',
  XPAY_RESTRICTED_ADMIN: 'xpay_restricted_admin',
  XPAY_PIM: 'pim',
  XPAY_SUBSCRIPTION_USER: 'xpay_subscription_user',
  XPAY_SUBSCRIPTION_MODULE_ONLY: 'xpay_subscription_module_only',
  XPAY_COPILOT_ADMIN: 'xstak-copilot-admin',
  USER_MANAGEMENT: 'xstak-copilot-admin',
};
export const Banks = Object.freeze({
  BAFL: 'bank-alfalah',
  HBL: 'hbl-cybersource',
  MCB: 'mcb',
  SAFE_PAY: 'safe-pay',
  PAY_FAST: 'pay-fast',
  CHECKOUT_COM: 'checkout',
  MBL: 'meezan-bank',
  JAZZ_CASH: 'jazzcash-wallet',
  EASY_PAISA: 'easypaisa-wallet',
  SOHAR_BANK: 'sohar-bank',
  MEEZAN_PAYPRO: 'meezan-paypro',
  UBL: 'ubl',
});
export const Wallets = Object.freeze({
  JAZZ_CASH: 'jazzcash-wallet',
  EASY_PAISA: 'easypaisa-wallet',
});
export const Bnpl = Object.freeze({
  BAADMAY: 'baadmay',
});
export const CARD_ACQUIRER_BANKS_NAMES = {
  [Banks.BAFL]: 'Bank Alfalah (MPGS)',
  [Banks.HBL]: 'Habib Bank (Cybersource)',
  [Banks.SAFE_PAY]: 'SafePay',
  [Banks.MCB]: 'Muslim Commercial Bank (MPGS)',
  [Banks.PAY_FAST]: 'Pay Fast',
  [Banks.CHECKOUT_COM]: 'Checkout.com',
  [Banks.MBL]: 'Meezan Bank (MBL)',
  [Banks.SOHAR_BANK]: 'Sohar International Bank',
  [Banks.MEEZAN_PAYPRO]: 'Meezan Paypro',
  [Banks.UBL]: 'United Bank Limited',
};
export const BANKS_NAMES = {
  [Banks.BAFL]: 'Bank Alfalah (MPGS)',
  [Banks.HBL]: 'Habib Bank (Cybersource)',
  [Banks.SAFE_PAY]: 'SafePay',
  [Banks.MCB]: 'Muslim Commercial Bank (MPGS)',
  [Banks.PAY_FAST]: 'Pay Fast',
  [Banks.CHECKOUT_COM]: 'Checkout.com',
  [Banks.MBL]: 'Meezan Bank (MBL)',
  [Banks.JAZZ_CASH]: 'JazzCash',
  [Banks.EASY_PAISA]: 'EasyPaisa',
  [Banks.SOHAR_BANK]: 'Sohar International Bank',
  [Bnpl.BAADMAY]: 'Baadmay',
  [Banks.MEEZAN_PAYPRO]: 'Meezan Paypro',
  [Banks.UBL]: 'United Bank Limited',
};
export const WALLET_NAMES = {
  [Wallets.JAZZ_CASH]: 'Jazz Cash',
  [Wallets.EASY_PAISA]: 'Easypaisa',
};

export const BNPL_NAMES = {
  [Bnpl.BAADMAY]: 'Baadmay',
};
export const RAAST_BANKS_NAMES = {
  [Banks.BAFL]: 'Bank Alfalah',
  [Banks.PAY_FAST]: 'Pay Fast',
};
export const GOOGLE_PAY_BANKS_NAMES = {
  [Banks.BAFL]: 'Bank Alfalah (MPGS)',
  [Banks.MCB]: 'Muslim Commercial Bank (MPGS)',
};
export const GATEWAY_INSTANCE_MODE = {
  INSTALLMENT_MODE: 'installment-payments',
  REGULAR_MODE: 'regular-payments',
};
export const GATEWAY_INSTANCE_MODE_NAME = {
  [GATEWAY_INSTANCE_MODE.INSTALLMENT_MODE]: 'Installment Payments',
  [GATEWAY_INSTANCE_MODE.REGULAR_MODE]: 'Regular Payments',
};
export const STORE_API_VERSION = {
  OCTOBER_23: '2023-10',
};
export const PAYMENT_METHOD_TYPES = {
  CARD: 'card',
  WALLET: 'wallet',
  BNPL: 'bnpl',
  RAAST: 'raast',
  GOOGLE_PAY:'Google Pay'
};
export const paymentType = [
  { label: 'All', value: 'all' },
  { label: 'CARD PAYMENT', value: 'card' },
  { label: 'WALLET PAYMENT', value: 'wallet' },
  { label: 'TOKEN PAYMENT', value: 'token' },
  { label: 'GOOGLE PAY', value: 'Google Pay' },
  { label: 'BNPL', value: 'bnpl' },
  { label: 'DQR', value: 'dqr' },
];
export const CHECKOUT_COM_AUTH_TYPE = {
  OAUTH: 'OAUTH',
  API: 'API',
};

export const TIMEZONES = {
  BST: 'Europe/London',
  AST: 'Asia/Riyadh',
  GST: 'Asia/Dubai',
  MST: 'Asia/Muscat',
  PKT: 'Asia/Karachi',
};

export const TIMEZONE = {
  [TIMEZONES.BST]: 'Europe/London (GMT+01:00)',
  [TIMEZONES.AST]: 'Asia/Riyadh (GMT+03:00)',
  [TIMEZONES.GST]: 'Asia/Dubai (GMT+04:00)',
  [TIMEZONES.MST]: 'Asia/Muscat (GMT+04:00)',
  [TIMEZONES.PKT]: 'Asia/Karachi (GMT+05:00)',
};

export const theme = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633',
};

export const tagColors = {
  AUTHENTICATION_FAILED: 'red',
  CAPTURED: 'success',
  YES: 'success',
  ENABLED: 'success',
  DISABLED: 'red',
  TIMEOUT: 'default',
  PENDING: 'gold',
  FAILED: 'red',
  REFUNDED: 'geekblue',
  AUTHORIZED_RISK_DECLINED: 'volcano',
  PARTIALLY_REFUNDED: 'cyan',
  Partially_Captured: 'cyan',
  AUTHENTICATION_PENDING: 'orange',
  AUTHENTICATION_NOT_SUPPORTED: 'red',
  CANCELLED: 'error',
  SUCCEEDED: 'success',
  PROCESSING: 'orange',
  REQUIRES_ACTION: 'purple',
  REQUIRES_CONFIRMATION: 'gold',
  AUTHENTICATION_SUCCESSFUL: 'orange',
  AUTHENTICATION_REJECTED: 'red',
  OTP_ACTION_REQUIRED: 'gold',
  PAYFAST_WEBHOOK_PENDING: 'gold',
  AUTHORIZATION_DECLINED: 'red',
  AUTHORIZATION_NOT_SUPPORTED: 'volcano',
  AUTHORIZATION_REJECTED: 'error',
  ACTIVE: 'geekblue',
  SETTLED: 'success',
  PAUSED: 'cyan',
  EXPIRED: 'volcano',
  PAID: 'success',
  COMPLETE: 'success',
  DRAFT: 'gold',
  INACTIVE: 'red',
  AUTHORIZED: 'purple',
  AUTHORIZED_DECLINED: 'red',
  AUTHENTICATION_UNAVAILABLE: 'red',
  Failed: 'red',
  AUTHENTICATION_UNSUCCESSFUL: 'red',
  AUTHENTICATION_AVAILABLE: 'orange',
  AUTHENTICATION_ATTEMPTED: 'orange',
  REQUIRES_PAYMENT_METHOD: 'orange',
};

export const COUNTRIES = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Anguilla',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Botswana',
  'Brazil',
  'British Virgin Islands',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Cape Verde',
  'Cayman Islands',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Congo',
  'Cook Islands',
  'Costa Rica',
  'Cote D Ivoire',
  'Croatia',
  'Cruise Ship',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Polynesia',
  'French West Indies',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kuwait',
  'Kyrgyz Republic',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macau',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Namibia',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Norway',
  'Oman',
  'Pakistan',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russia',
  'Rwanda',
  'Samoa',
  'San Marino',
  'Satellite',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'South Africa',
  'South Korea',
  'Spain',
  'Sri Lanka',
  'St Lucia',
  'St Vincent',
  'St. Lucia',
  'Sudan',
  'Suriname',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  "Timor L'Este",
  'Togo',
  'Tonga',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Venezuela',
  'Vietnam',
  'Virgin Islands (US)',
  'Yemen',
  'Zambia',
  'Zimbabwe',
  'AF',
  'AL',
  'DZ',
  'AD',
  'AO',
  'AG',
  'AR',
  'AM',
  'AU',
  'AT',
  'AZ',
  'BS',
  'BH',
  'BD',
  'BB',
  'BY',
  'BE',
  'BZ',
  'BJ',
  'BT',
  'BO',
  'BA',
  'BW',
  'BR',
  'BN',
  'BG',
  'BF',
  'BI',
  'CV',
  'KH',
  'CM',
  'CA',
  'CF',
  'TD',
  'CL',
  'CN',
  'CO',
  'KM',
  'CG',
  'CR',
  'HR',
  'CU',
  'CY',
  'CZ',
  'CD',
  'DK',
  'DJ',
  'DM',
  'DO',
  'EC',
  'EG',
  'SV',
  'GQ',
  'ER',
  'EE',
  'SZ',
  'ET',
  'FJ',
  'FI',
  'FR',
  'GA',
  'GM',
  'GE',
  'DE',
  'GH',
  'GR',
  'GD',
  'GT',
  'GN',
  'GW',
  'GY',
  'HT',
  'HN',
  'HU',
  'IS',
  'IN',
  'ID',
  'IR',
  'IQ',
  'IE',
  'IL',
  'IT',
  'JM',
  'JP',
  'JO',
  'KZ',
  'KE',
  'KI',
  'XK',
  'KW',
  'KG',
  'LA',
  'LV',
  'LB',
  'LS',
  'LR',
  'LY',
  'LI',
  'LT',
  'LU',
  'MG',
  'MW',
  'MY',
  'MV',
  'ML',
  'MT',
  'MH',
  'MR',
  'MU',
  'MX',
  'FM',
  'MD',
  'MC',
  'MN',
  'ME',
  'MA',
  'MZ',
  'MM',
  'NA',
  'NR',
  'NP',
  'NL',
  'NZ',
  'NI',
  'NE',
  'NG',
  'KP',
  'MK',
  'NO',
  'OM',
  'PK',
  'PW',
  'PS',
  'PA',
  'PG',
  'PY',
  'PE',
  'PH',
  'PL',
  'PT',
  'QA',
  'RO',
  'RU',
  'RW',
  'KN',
  'LC',
  'VC',
  'WS',
  'SM',
  'ST',
  'SA',
  'SN',
  'RS',
  'SC',
  'SL',
  'SG',
  'SK',
  'SI',
  'SB',
  'SO',
  'ZA',
  'KR',
  'SS',
  'ES',
  'LK',
  'SD',
  'SR',
  'SE',
  'CH',
  'SY',
  'TW',
  'TJ',
  'TZ',
  'TH',
  'TL',
  'TG',
  'TO',
  'TT',
  'TN',
  'TR',
  'TM',
  'TV',
  'UG',
  'UA',
  'AE',
  'GB',
  'US',
  'UY',
  'UZ',
  'VU',
  'VA',
  'VE',
  'VN',
  'YE',
  'ZM',
  'ZW',
];

export const pricingTypes = {
  PERCENTAGE: 'percentage',
  STANDARD: 'standard',
  VOLUME: 'volume',
  TIERED: 'tiered',
  FIXED: 'fixed-retainer',
};

export const chargeTypes = {
  PERCENTAGE: 'percentage',
  STANDARD: 'standard',
  VOLUME: 'volume',
  TIERED: 'tiered',
  COMPOSITE: 'composite',
};

export const StoreBlockList = {
  emails: 'Email Address',
  bins: 'Bin',
  phone_numbers: 'Phone',
  ip_addresses: 'IP Address',
  card_fingerprints: 'Card',
};

export const methodGatewaysNameFormatting = {
  'card': 'Card',
  'bank-alfalah': 'Bank Alfalah',
  'checkout': 'Checkout.com',
  'test-bank-alfalah': 'Bank Alfalah (Test)',
  'hbl-cybersource': 'Habib Bank (Cybersource)',
  'pay-fast': 'Pay Fast',
  'jazzcash-wallet': 'JazzCash',
  'xstak-pay': 'Xstak Pay',
  'meezan-bank': 'Meezan Bank',
  'baadmay': 'Baadmay',
  'easypaisa-wallet': 'Easypaisa',
  'mcb': 'Muslim Commercial Bank',
  'safe-pay': 'SafePay',
  'meezan-paypro': 'Meezan Paypro',
  'sohar-bank': 'Sohar International Bank',
  'apg': 'Alfa Payment Gateway',
  'postex': 'Postex',
  'token': 'Token',
  '': 'Unknown',
  'unknown': 'Unknown',
  'raast': 'Raast',
  'dqr': 'DQR',
  'rtp': 'RTP',
  'google pay': 'Google Pay',
  'bnpl': 'BNPL',
  'wallet': 'Wallet',
  'ubl': 'United Bank Limited',
};
